import React, {useContext, useState, useEffect} from "react"
import moment from "moment"
import Typography from "@material-ui/core/Typography"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"

import {Link} from "react-router-dom"
import TableRow from "@material-ui/core/TableRow"
import ShelfApi from "~/utils/ShelfApi.js"
import {ShoppingCartContext} from "../context/ShoppingCartContext"
import Button from "~/components/Button"
import {displayCHF} from "../helpers/number"

import {
  Form,
  FormSection,
  Field,
  TitleSection,
  List,
  ListItemOrderHistory,
  ShoppingCartQuantityBox
} from "~/components/"

import {useTranslation} from "react-i18next"

const icon_delete = require("~/icons/action_delete.svg")

const ShoppingCartView = () => {
  const {t} = useTranslation()
  const {shoppingCart, archivedShoppingCarts, updateShoppingCart} = useContext(
    ShoppingCartContext
  )
  const [orderFormFields, setOrderFormFields] = useState({comment: ""})
  const [error, setError] = useState("")
  const [shoppingCartItems, setShoppingCartItems] = useState([])

  useEffect(() => {
    if (shoppingCart.product_in_carts) {
      setShoppingCartItems(shoppingCart.product_in_carts)
    }
  }, [shoppingCart])

  const submitOrder = () =>
    new Promise((resolve, reject) => {
      ShelfApi.put(`/shopping_carts/${shoppingCart.id}/`, {
        shopping_cart: {comment: orderFormFields.comment}
      })
        .then(res => {
          ShelfApi.post(`/shopping_carts/${shoppingCart.id}/order/`, {})
            .then(res => {
              resolve()
              updateShoppingCart()
            })
            .catch(e => {
              reject({
                response: {data: t("shoppingCart.orderError")}
              })
              setError(t("shoppingCart.orderError"))
            })
        })
        .catch(e => {
          reject({response: {data: t("shoppingCard.orderError")}})
          setError(t("shoppingCart.orderError"))
        })
    })

  const deletePosition = shoppingCartItemId => {
    if (window.confirm(t("shoppingCart.deletePositionConfirmation"))) {
      ShelfApi.delete(`/product_in_carts/${shoppingCartItemId}/`)
        .then(res => {
          updateShoppingCart()
        })
        .catch(e => {
          setError(t("shoppingCart.deletePositionError"))
        })
    }
  }

  return (
    <div>
      <TitleSection>
        <h3>{t("shoppingCart.title")}</h3>
      </TitleSection>

      <div className="shopping-cart-list">
        <TableContainer style={{padding: 20, boxSizing: "border-box"}}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{t("shoppingCart.article")}</TableCell>
                <TableCell align="left">{t("shoppingCart.quantity")}</TableCell>
                <TableCell align="right">{t("shoppingCart.brutto")}</TableCell>
                <TableCell align="center">
                  {t("shoppingCart.discount")}
                </TableCell>
                <TableCell align="right">{t("shoppingCart.netto")}</TableCell>
                <TableCell align="right">{t("shoppingCart.total")}</TableCell>
                <TableCell align="center">{t("shoppingCart.delete")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shoppingCartItems
                .sort((a, b) => a.id - b.id)
                .map((row, index) => (
                  <TableRow key={row.name}>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{cursor: "pointer"}}
                    >
                      <Link to={`/product/${row.product.id}`}>
                        <Typography variant="h6">
                          Pos. {index + 1} {row.product.name}
                        </Typography>
                        <Typography variant="subtitle1">
                          {t("shoppingCart.addedByAt", {
                            email: row.user.email,
                            addedAt: moment(row.added_at).format("DD.MM.YYYY")
                          })}
                        </Typography>
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <ShoppingCartQuantityBox
                        row={row}
                        onUpdateQuantity={() => updateShoppingCart()}
                      />
                    </TableCell>
                    <TableCell align="right">
                      {displayCHF(row.product.brutto_price)}
                    </TableCell>
                    <TableCell align="center">
                      {row.product.discount_factor
                        ? `${row.product.discount_factor.toFixed(2)}%`
                        : "–"}
                    </TableCell>
                    <TableCell align="right">
                      {displayCHF(row.product.net_price)}
                    </TableCell>
                    <TableCell align="right" style={{minWidth: 100}}>
                      {displayCHF(row.product.net_price * row.quantity)}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        onClick={() => {
                          deletePosition(row.id)
                        }}
                        icon={icon_delete}
                        label=""
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        {shoppingCartItems.length > 0 && (
          <div>
            <Form
              submitLabel={t("shoppingCart.order")}
              onSubmit={() => submitOrder()}
              then="/shopping_cart"
            >
              <FormSection>
                <Field
                  label={t("shoppingCart.note")}
                  type="textarea"
                  name="comment"
                  value={orderFormFields.comment}
                  onChange={e =>
                    setOrderFormFields({
                      ...orderFormFields,
                      ...{comment: e.target.value}
                    })
                  }
                />
              </FormSection>
            </Form>
            <div className="error">{error}</div>
          </div>
        )}
      </div>

      {archivedShoppingCarts.length > 0 && (
        <div>
          <TitleSection>
            <h3>{t("shoppingCart.closedOrders")}</h3>
          </TitleSection>
          <List
            items={archivedShoppingCarts}
            itemRenderer={ListItemOrderHistory}
          />
        </div>
      )}
    </div>
  )
}

export default ShoppingCartView



// WEBPACK FOOTER //
// ./src/views/ShoppingCartView.js